import React from 'react';
import PropTypes from 'prop-types';

import './Input.scss';

export default function OTPInput(props) {
  const { 
    formData = {}, handleInputChange = () => {}, otp = '', resendTimer = 0, otpSent = false, handleResendOTP = () => {} 
  } = props;

  const handleOTPChange = (e) => {
    const value = e.target.value.replace(/\D/g, '').slice(0, 6);
    handleInputChange({
      target: {
        name: 'otp',
        value: value
      }
    });
  };

  return (
    <div className="OTPInputWrapper">
      <input 
        className="otpInput" 
        id="otp" 
        name="otp"
        type="text" 
        placeholder="Enter OTP" 
        pattern="[0-9]{6}"
        minLength={6} 
        maxLength={6} 
        inputMode="numeric" 
        value={formData.otp || ''}
        onChange={handleOTPChange}
      />

      <span className="redStar" style={{ '--redStarDisplay': otp ? 'none' : 'block' }}>*</span>

      {/* {errors.otp && <p className="errorOtp">{errors.otp}</p>} */}

      <div className="resendText">
        {resendTimer > 0 && otpSent ? (
          <button className="textResend" disabled>
            Resend OTP in: {Math.floor(resendTimer / 60)}: {("0" + (resendTimer % 60)).slice(-2)}
          </button>
        ) : (
          <button className="textResend underline" onClick={(e) => handleResendOTP(e)}>
            Resend OTP
          </button>
        )}
      </div>
    </div>
  );
}

OTPInput.propTypes = {
  formData: PropTypes.object,
  handleInputChange: PropTypes.func,
  errors: PropTypes.object,
  otp: PropTypes.string,
  resendTimer: PropTypes.number,
  otpSent: PropTypes.bool,
  handleResendOTP: PropTypes.func,
};